import m from 'mithril';
import {has_permission} from "../helpers";

let state = {
	id_user: SPORTNETXPAGE.USER ? SPORTNETXPAGE.USER.id_user : null,
    
    is_admin: SPORTNETXPAGE.USER ? SPORTNETXPAGE.USER.roles.includes('Fit Admin') : false,
    
    id_challenge: null,
    id_exercise: null,

    mode: 'insert',

    challenge: null,

    challenge_types: [],
    challenge_types_code_to_id: {},
    challenge_types_id_to_code: {},
    
    entry_types: [],

    exercises : [],

    selected_exercises_to_show_first : [], // these exercises will be put on the beggining of the select exercise searcher

    groups : [],

    // loading_exercises: false,

    search_exercises: {
        loading: false,
        load_more: false,
        limit: 8,
        page: 1,
        query: '',
        sports: { list: [] },
        groups: {}
    },

    current_step: 'select_exercises',
    // current_step: 'create_challenge',
    // current_step: 'challenge_visibility',
    // current_step: 'edit_exercise_content',
    
    new_exercise: {},
    exercise_loading: false,

    exercise_editor_state: {},

    roles: [],
    new_role_id: 1,

    exercise_validation: {
        title:             'required|min:4',
        short_description: 'max:100',
    },

    challenge_validation: {
        title:             'required|min:4',
        // description:       'required|min:10',
        id_type:           'required',
        starts_at:         'required',
        // ends_at:           'required',
    },

    available_organizations: {
        list: []
    },

    set_ends_at: false,

    get_empty_challenge: function() {
        let organizations_list = [];

        if (!has_permission('challenges.canCreatePublic')) {
            let available_organizations = Object.keys(SPORTNETXPAGE.USER_DATA.organizations);
            if (available_organizations.length == 1) {
                let org = SPORTNETXPAGE.USER_DATA.organizations[available_organizations[0]];
                organizations_list = [org];
            }
        }

        return {
            // id_challenge: "24",  //TO DEJ VEN!!
            // slug: "gkQP4P",  //TO DEJ VEN!!
            title: null,
            subtitle: null,
            description: null,
            id_type: 0,
            id_entry_type: null,
            starts_at: new Date().toISOString().split("T")[0],
            ends_at: null,
            url_poster: null,
            available: 1,
            public:  1,
            unlisted: 0,
            exposed: 0,
            is_sst: 0,
            data : {},
            exercises : [],
            requested_public: 0,
            // organizations: [],
            organizations: {
                list: organizations_list,
                timeout: null
            },
            roles: [],
            groups: {},
            sports: { list: [] }
        }
    },

    get_empty_exercise: function() {
        return {
            // id_exercise: "18",
            // id_exercise: "216", //TO DEJ VEN!!
            title: '',
            short_description: '',
            required_people: 1,
            type: 0,
            url_poster: '',
            public: has_permission('exercises.canCreatePublic') ? 1 : 0,
            unlisted: 0,
            groups: {},
            sports: { list: [] }
        }
    },

    get_empty_exercise_editor_state: function() {
        return {
            id_exercise: null,
            exercise: null,
            editor: null,
            images_cache: {},
            videos_cache: {}
        }
    },

    validate_form: function(validation_fields, to_check) {
        let problems = {};

        for (var key in validation_fields) {
            if (!validation_fields.hasOwnProperty(key)) continue;

            let field = validation_fields[key];

            let rules = field.split("|");

            rules.forEach(r => {

                let r_key = r.split(":")[0];

                if (r_key == "required") {
                    let v = to_check[key];

                    if (!v || v == null || v == '' || v == 0) {
                        problems[key] = r;
                        return;
                    }
                }

                if (r_key == "min") {
                    if (key in problems && problems[key] == "required")
                        return;

                    let v = to_check[key];
                    let r_v = parseInt(r.split(":")[1]);

                    if (v.length < r_v) {
                        problems[key] = r;
                        return;
                    }
                }

                if (r_key == "max") {
                    if (key in problems && problems[key] == "required")
                        return;

                    let v = to_check[key];
                    let r_v = parseInt(r.split(":")[1]);

                    if (v.length > r_v) {
                        problems[key] = r;
                        return;
                    }
                }
            });
        }

        return problems;
    }
}

module.exports = state;